// 写一个深克隆
/**
 * 深克隆函数 - 支持多种数据类型的深度复制
 * @param {any} target - 需要克隆的目标对象
 * @param {WeakMap} [hash=new WeakMap()] - 用于处理循环引用的哈希表
 * @returns {any} 克隆后的新对象
 */

export default function deepClone(target, hash = new WeakMap()) {
  // 基本类型直接返回
  if (target === null || typeof target !== 'object') {
    return target
  }

  // 处理日期对象
  if (target instanceof Date) {
    return new Date(target)
  }

  // 处理正则对象
  if (target instanceof RegExp) {
    return new RegExp(target.source, target.flags)
  }

  // 处理循环引用
  if (hash.has(target)) {
    return hash.get(target)
  }

  // 处理数组和对象
  const cloneTarget = Array.isArray(target) ? [] : {}
  hash.set(target, cloneTarget)

  // 处理Symbol属性
  const symbols = Object.getOwnPropertySymbols(target)
  if (symbols.length > 0) {
    symbols.forEach(symbol => {
      cloneTarget[symbol] = deepClone(target[symbol], hash)
    })
  }

  // 递归克隆属性
  Reflect.ownKeys(target).forEach(key => {
    cloneTarget[key] = deepClone(target[key], hash)
  })

  return cloneTarget
}

